import { Outlet } from 'react-router-dom';

const Staff = () => {
  return <Outlet />;
};

export default Staff;
